import Colors from 'constants/Colors';

export default {
  valueContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  section: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
    height: 54,
    padding: 8,
    backgroundColor: Colors.dynamicFormColor,
    color: Colors.white,
    fontWeight: 'bold',
  },
  selectFieldText: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '8px 4px',
    alignItems: 'left',
    fontSize: 12,
    fontWeight: 'bold',
    backgroundColor: Colors.lightGray,
    borderLeft: `3px solid ${Colors.black}`
  },
  selectField: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
    height: 54,
    padding: 4,
    backgroundColor: '#F2FBFF',
    borderLeft: `3px solid ${Colors.blueColor}`,
  },
  fieldStatus: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    fontWeight: 600,
    padding: '1px 6px',
    borderRadius: '10px',
  },
  iconStyle: {
    width: '6px', 
    height: '6px', 
    borderRadius: '50%', 
    marginRight: '4px', 
  },
};
